module.exports = "/img/white_spinner.gif?2bff056d3532ffbe378a566bbeadb516";